/* eslint-disable react/jsx-indent */
import React from "react";
import { func, bool, number, string, object, array } from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Form, Alert } from "react-bootstrap";
import Cookies from "js-cookie";
import queryString from "query-string";
import jwtDecode from "jwt-decode";
import Loader from "react-loader-advanced";
import { ThreeBounce } from "better-react-spinkit";
import { getSubDomain } from "utils/helperFunctions";
import EmailInput from "./EmailInput";
import PasswordInput from "./PasswordInput";
import ForgotForm from "./ForgotForm";
import SetPasswordForm from "./SetPasswordForm";
import NotVerifiedPage from "./NotVerifiedPage";
import InvalidVerifyLinkPage from "./InvalidVerifyLinkPage";
import VerifyLoadingPage from "./VerifyLoadingPage";
import circleInfo from "../../../resources/images/circle-info-light-blue@3x.png";
import {
  login,
  resetPassword,
  clearResetEmailErrors,
  getIdentityProvider,
  resetErrorCode,
  checkValidVerifyToken,
  resendVerificationEmail,
} from "../actions";
import {
  getIdpLoginRedirectUrl,
  getSecuredLoginParams,
  determineLoginFlow,
} from "../helpers";
import PostHireSSORedirect from "./PostHireSSORedirect";

export class LoginForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      emailAddress: "",
      loginPasswordInput: "",
      showResetModal:
        !this.props.showInvalidVerifyLink && this.props.expiredToken,
      emailValidated: false,
      loadingIdProvider: false,
      loginStep: 1,
      showSsoLogoutMsg: false,
      redirectingToIdp: false,
      showNotVerifiedPage: false,
    };
  }

  UNSAFE_componentWillMount() {
    const queryParams = queryString.parse(window.location.search);

    const verifyToken =
      window.location.pathname === "/verifyAccount" && queryParams?.verifyToken;

    if (verifyToken) {
      this.props.onCheckValidVerifyToken(verifyToken);
    } else if (queryParams && queryParams.companyAccountId) {
      this.setState({
        loginStep: 2,
      });
      this.props.onGetIdentityProvider(null, queryParams.companyAccountId);
    } else if (
      Cookies.get()["_Secure-cog-user"] &&
      JSON.parse(Cookies.get()["_Secure-cog-user"]).emailAddress.length > 0
    ) {
      const userCookie = JSON.parse(Cookies.get()["_Secure-cog-user"]);
      this.props.setRememberMe(true);

      if (this.props.identityProviderMode === null) {
        this.props.onGetIdentityProvider(userCookie.emailAddress);
      }

      this.setState({
        loginStep: 2,
        emailAddress: userCookie.emailAddress,
      });
    } else if (
      this.state.loginStep === 2 &&
      this.state.emailAddress.length < 1
    ) {
      this.setState({ loginStep: 1 });
    }
    // if logging out of sso enabled account, ssoLogout will be availble. Show msg and delete variable
    if (sessionStorage.getItem("ssoLogout")) {
      sessionStorage.removeItem("ssoLogout");
      this.setState({ showSsoLogoutMsg: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if (
    //   nextProps.identityProviderMode !== null &&
    //   nextProps.identityProviderMode === 0 &&
    //   nextProps.identityProviderInfo.get('mfaEnabled') === 2
    // ) {
    //   return;
    // }

    const isUserVerified = nextProps.identityProviderInfo?.get("isVerified");

    if (isUserVerified !== null && !isUserVerified) {
      this.setState({ showNotVerifiedPage: true, loadingIdProvider: false });
    }

    if (
      this.props.identityProviderMode === null &&
      nextProps.identityProviderMode !== null &&
      isUserVerified &&
      ((queryString.parse(window.location.search) &&
        queryString.parse(window.location.search).companyAccountId) ||
        this.state.emailAddress.length > 0)
    ) {
      this.setState({ loadingIdProvider: false, loginStep: 2 });
      if (nextProps.identityProviderMode < 2) {
        setTimeout(() => {
          if (document.getElementById("loginPasswordInput")) {
            document.getElementById("loginPasswordInput").focus();
          }
        }, 200);
      }
    }
  }

  updateLoginFormValidation = (emailValidated) => {
    this.setState({ emailValidated });
  };

  /* ----------- Event Handlers ------------- */
  handleInput = (event) => {
    const field = event.target.id;
    const { value } = event.target;

    this.setState({ [field]: value });
  };

  handleRememberMe = (e) => {
    this.props.setRememberMe(e.target.checked);
  };

  checkEmailValid = () => {
    const emailSplit = this.state.emailAddress.split("@");
    return (
      typeof emailSplit[0] === "string" &&
      emailSplit[0].length > 0 &&
      typeof emailSplit[1] === "string" &&
      emailSplit[1].length > 0
    );
  };

  handleSubmitEmail = (e) => {
    e.preventDefault();
    if (this.state.emailAddress.length < 1 || !this.checkEmailValid()) {
      e.stopPropagation();
      this.updateLoginFormValidation(true);
    } else {
      this.setState({ loadingIdProvider: true });
      this.props.onGetIdentityProvider(
        this.state.emailAddress,
        null
        // this.props.rememberMe ? 1 : 0
      );
    }
  };

  handleSubmitPassword = (e) => {
    if (e) {
      e.preventDefault();
      // TODO: figure out why showResetModal is being set to true when a user submits an
      // TODO: incorrect password, then follows that up with a correct one and presses enter.
      // TODO: for now, this fixes it.
      this.setState({ showResetModal: false });
      const formData = {
        emailAddress: this.state.emailAddress,
        password: this.state.loginPasswordInput,
        rememberMe: this.props.rememberMe ? 1 : 0,
      };
      const liOnboardingIntegrationData = this.props.liOnboarding
        ? queryString.parse(window.location.search)
        : null;
      this.props.onLogin(
        formData,
        this.props.liOnboarding,
        liOnboardingIntegrationData
      );
    }
  };

  handleSubmitForm = (e) => {
    if (this.state.loginStep === 1) {
      this.handleSubmitEmail(e);
    } else {
      this.handleSubmitPassword(e);
    }
  };

  showResetModal = () => {
    this.setState({ showResetModal: true, showSsoLogoutMsg: false });
  };

  returnToEmail = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    // if the user is on the forgot password page after clicking an expired reset password link
    // we want to make sure "back to login" takes them back to the login page
    if (this.state.showResetModal && this.props.tk1 && this.props.tk2) {
      window.location = "/";
      return false;
    }

    this.setState({
      emailAddress: "",
      loginPasswordInput: "",
      showResetModal: this.props.expiredToken,
      emailValidated: false,
      loadingIdProvider: false,
      loginStep: 1,
      showNotVerifiedPage: false,
    });

    this.props.setRememberMe(false);
    this.props.onResetErrorCode();
    Cookies.remove("_Secure-cog-user");

    return false;
  };

  handleIdPLogin = (/* loginType */) => {
    this.setState({ redirectingToIdp: true, showSsoLogoutMsg: false }, () => {
      // setting params for secured login
      const { ranDoCd, verifier, challenge } = getSecuredLoginParams(
        this.state.emailAddress
      );

      // save to session storage
      sessionStorage.setItem("logState", ranDoCd);
      sessionStorage.setItem("logVerif", verifier);
      sessionStorage.setItem("rememberMe", this.props.rememberMe);
      sessionStorage.setItem("loginPath", window.location.pathname);

      // redirecting
      const redirectUrl = getIdpLoginRedirectUrl(
        this.props.identityProviderInfo,
        ranDoCd,
        challenge
      );

      window.location = redirectUrl;
    });
  };

  handleDevelopSSOLogin = () => {
    // first we will look at the queryParams to see if develop_ssoEmail is present
    const queryParams = queryString.parse(window.location.search);
    const { develop_ssoEmail } = queryParams;

    // if not present return.
    if (!develop_ssoEmail) {
      return;
    }
    this.setState({ redirectingToIdp: true });
    const { ranDoCd, challenge, verifier } =
      getSecuredLoginParams(develop_ssoEmail);

    sessionStorage.setItem("logState", ranDoCd);
    sessionStorage.setItem("logVerif", verifier);
    sessionStorage.setItem("rememberMe", this.props.rememberMe);

    const redirectUrl = getIdpLoginRedirectUrl(
      this.props.identityProviderInfo,
      ranDoCd,
      challenge
    );

    window.location = redirectUrl;
  };

  handleOpenHelpCenter = () => {
    const isAU = getSubDomain() === "app-au";

    const url = isAU
      ? "https://criteriacorp.helpdocs.io/article/psvk9zgwxb-login-troubleshooting"
      : "https://criteria.helpdocs.io/article/hkj2l8o3it-logging-in-to-your-criteria-platform-account";

    window.open(url, "_blank");
  };

  handleResendVerificationEmail = () => {
    const queryParams = queryString.parse(window.location.search);

    const verifyToken =
      window.location.pathname === "/verifyAccount" && queryParams?.verifyToken;

    if (this.state.emailAddress) {
      this.props.onResendVerificationEmail(this.state.emailAddress);
    } else if (verifyToken) {
      const decodedVerifyToken = jwtDecode(verifyToken);

      this.props.onResendVerificationEmail(decodedVerifyToken.email);
    }
  };

  render() {
    // style variables
    const linkButtonStyle = {
      color: "#193783",
      textDecoration: "underline",
      backgroundColor: "none",
      border: "0",
      textAlign: "center",
      margin: 0,
      padding: 0,
    };

    const {
      status,
      liOnboarding,
      showInvalidVerifyLink,
      verifyLinkInvalid,
      resendVerificationEmailSuccess,
      checkValidVerifyTokenLoading,
      showUserVerified,
    } = this.props;

    const isAU = getSubDomain() === "app-au";
    const centerLocaleText = isAU ? "centre" : "center";

    /*
     * We set the errorMessage here, depending on which errorCode, if any, is returned from the login API call. Ideally,
     * this would be extracted to a separate method in a helper file, but the onClick handlers and styling doesn't pass
     * through correctly if it is.
     */

    let errorMessage;
    switch (this.props.errorCode) {
      case 2:
        errorMessage = (
          <div>
            <p>
              For security reasons, no more than 10 failed login attempts in a
              30 minute period are allowed. Please try again later.
            </p>
            <p>
              You can also unlock your account by resetting your password. Reset
              your password{" "}
              <button
                style={linkButtonStyle}
                onClick={this.showResetModal}
                id="resetPassword"
                type="button"
              >
                here
              </button>
              .
            </p>
          </div>
        );
        break;
      case 1:
      case 3:
        errorMessage = (
          <div>
            Invalid email address and/or password. Reset your password{" "}
            <button
              type="button"
              style={linkButtonStyle}
              onClick={this.showResetModal}
              id="resetPassword"
            >
              here
            </button>
            .
            <br />
            Need additional help logging in? Visit our{" "}
            <button
              type="button"
              style={linkButtonStyle}
              onClick={this.handleOpenHelpCenter}
              id="openHelpCenter"
            >
              help {centerLocaleText}
            </button>
            .
          </div>
        );
        break;
      case 4:
        errorMessage = "Your account is inactive";
        break;
      case 5:
        errorMessage = (
          <div // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html:
                'Attention: Login failed. Some of the information you provided when you signed up for a free trial of Criteria was incorrect.<br>To reactivate your free trial account, please contact <a href="mailto:sales@criteriacorp.com">sales@criteriacorp.com</a> or call 1 877 909 8378. Thank you.',
            }}
          />
        );
        break;
      case 6:
        errorMessage = "You no longer have access to Talent Insights.";
        break;
      default:
        errorMessage = null;
        break;
    }

    const loginFlow = determineLoginFlow(
      status,
      this.state.showResetModal,
      showUserVerified
      // this.state.loadingIdProvider,
      // this.props.identityProviderMode,
      // this.props.identityProviderInfo
    );

    const onCompanySsoLoginUrl =
      queryString.parse(window.location.search) &&
      queryString.parse(window.location.search).companyAccountId;

    const showForgotPasswordLink =
      !this.state.showResetModal &&
      !onCompanySsoLoginUrl &&
      !this.state.redirectingToIdp /* &&
      loginFlow !== 'mfaRedirect' */ &&
      (this.props.identityProviderMode !== 2 || this.props.allowPassword) &&
      !this.state.showNotVerifiedPage &&
      status !== "verify" &&
      !showInvalidVerifyLink &&
      status !== "reset";

    const queryParams = queryString.parse(window.location.search);

    const verifyToken =
      window.location.pathname === "/verifyAccount" && queryParams.verifyToken;

    const showInvalidLinkPage =
      showInvalidVerifyLink || (verifyLinkInvalid && status === "verify");

    const showVerifyLoadingPage = verifyToken && checkValidVerifyTokenLoading;

    return (
      <Row className="justify-content-center mt-5">
        <Col lg={6} md={8} sm={12} className="text-left">
          {showVerifyLoadingPage ? (
            <VerifyLoadingPage />
          ) : (
            <>
              {this.state.showResetModal && (
                <ForgotForm
                  onResetPassword={this.props.onResetPassword}
                  returnToEmail={this.returnToEmail}
                  emailAddress={this.state.emailAddress}
                />
              )}
              {status === "reset" && !this.state.showResetModal && (
                <SetPasswordForm tk1={this.props.tk1} tk2={this.props.tk2} />
              )}
              {status === "verify" &&
                !showUserVerified &&
                !showInvalidLinkPage &&
                !this.state.showResetModal && (
                  <SetPasswordForm verifyToken={verifyToken} />
                )}
              {this.state.showNotVerifiedPage && !this.state.showResetModal && (
                <NotVerifiedPage
                  emailAddress={this.state.emailAddress}
                  handleResendVerificationEmail={
                    this.handleResendVerificationEmail
                  }
                  returnToEmail={this.returnToEmail}
                  resendVerificationEmailSuccess={
                    resendVerificationEmailSuccess
                  }
                />
              )}
              {!this.state.showResetModal &&
                showInvalidLinkPage &&
                !showUserVerified && (
                  <InvalidVerifyLinkPage
                    verifyToken={verifyToken}
                    handleResendVerificationEmail={
                      this.handleResendVerificationEmail
                    }
                    resendVerificationEmailSuccess={
                      resendVerificationEmailSuccess
                    }
                  />
                )}
              {this.state.showSsoLogoutMsg && (
                <Alert className="error-messages" variant="warning">
                  <div>
                    You have been logged out of Criteria. Please note that this
                    will not log you out of your SSO provider.
                  </div>
                </Alert>
              )}
              {queryString.parse(window.location.search).login && (
                <Alert
                  className="error-messages d-flex"
                  style={{
                    padding: "16px",
                    fontSize: "14px",
                    backgroundColor: "#eaf9fa",
                    border: "1px solid #d5f5f6",
                    color: "#166669",
                  }}
                >
                  <img
                    src={circleInfo}
                    alt="info-circle"
                    style={{ height: "16px", marginRight: "16px" }}
                  />
                  <div>
                    It looks like you have already signed up. Please log in
                    below to continue.
                  </div>
                </Alert>
              )}
              <Form
                noValidate
                validated={
                  this.state.loginStep === 1 ? this.state.emailValidated : false
                }
                onSubmit={this.handleSubmitForm}
              >
                {this.state
                  .redirectingToIdp /* || loginFlow === 'mfaRedirect' */ ? (
                  <div style={{ margin: "auto" }}>
                    <Loader
                      show
                      message={
                        <span>
                          <p
                            className="d-inline-block"
                            style={{
                              fontSize: "20px",
                              color: "black",
                              marginRight: "14px",
                            }}
                          >
                            Please wait
                          </p>
                          <ThreeBounce color="#1F469A" size={15} />
                        </span>
                      }
                      contentBlur={30}
                      backgroundStyle={{
                        backgroundColor: "rgba( 0 0 0 0)",
                        position: "relative",
                        paddingBottom: "25px",
                        paddingTop: "25px",
                      }}
                    />
                  </div>
                ) : null}
                {!this.state.redirectingToIdp &&
                !this.state.showNotVerifiedPage &&
                loginFlow === "passwordLogin" ? (
                  <>
                    <EmailInput
                      emailAddress={this.state.emailAddress}
                      handleEmailInput={this.handleInput}
                      emailValidated={this.state.emailValidated}
                      rememberMe={this.props.rememberMe}
                      handleRememberMe={this.handleRememberMe}
                      loadingIdProvider={this.state.loadingIdProvider}
                      resetEmailSent={this.props.resetEmailSent}
                      showLoginUpdateNotification={
                        this.props.showLoginUpdateNotification
                      }
                      loginStep={this.state.loginStep}
                      ssoError={this.props.ssoError}
                      errorMessage={errorMessage}
                      passwordReset={status === "passwordReset"}
                      liOnboarding={liOnboarding}
                      showUserVerified={showUserVerified}
                    />
                    <PasswordInput
                      emailAddress={this.state.emailAddress}
                      password={this.state.loginPasswordInput}
                      identityProviderMode={this.props.identityProviderMode}
                      allowPassword={this.props.allowPassword}
                      identityProviderName={
                        this.props.identityProviderInfo
                          .get("identityProviderName")
                          .split("-")[0]
                      }
                      handleIdPLogin={this.handleIdPLogin}
                      handlePasswordInput={this.handleInput}
                      returnToEmail={this.returnToEmail}
                      errorCode={this.props.errorCode}
                      errorMessage={errorMessage}
                      loginStep={this.state.loginStep}
                      liOnboarding={liOnboarding}
                      // mfaEnabled={this.props.identityProviderInfo.get('mfaEnabled')}
                      redirectingToIdp={this.state.redirectingToIdp}
                    />
                  </>
                ) : null}
              </Form>
              {showForgotPasswordLink && (
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn-as-link-no-state font-weight-bold"
                    onClick={this.showResetModal}
                    id="forgotPassword"
                    style={{ fontSize: "14px" }}
                    disabled={this.state.loadingIdProvider}
                  >
                    Forgot your password?
                  </button>
                </div>
              )}
            </>
          )}
        </Col>
        <PostHireSSORedirect onSSORedirect={this.handleDevelopSSOLogin} />
      </Row>
    );
  }
}

LoginForm.propTypes = {
  onLogin: func.isRequired,
  errorCode: number,
  ssoError: array,
  resetEmailSent: bool.isRequired,
  onResetPassword: func.isRequired,
  status: string,
  tk1: string,
  tk2: string,
  expiredToken: bool.isRequired,
  identityProviderMode: number,
  allowPassword: bool,
  identityProviderInfo: object,
  rememberMe: bool,
  showLoginUpdateNotification: bool,
  setRememberMe: func.isRequired,
  onGetIdentityProvider: func.isRequired,
  onResetErrorCode: func.isRequired,
  liOnboarding: bool,
  showInvalidVerifyLink: bool,
  onCheckValidVerifyToken: func.isRequired,
  onResendVerificationEmail: func.isRequired,
  verifyLinkInvalid: bool,
  resendVerificationEmailSuccess: bool,
  checkValidVerifyTokenLoading: bool,
  showUserVerified: bool,
};

const mapStateToProps = (state) => ({
  resetEmailSent: state.get("App").get("resetEmailSent"),
  errorCode: state.get("App").get("errorCode"),
  ssoError: state.get("App").get("ssoError"),
  identityProviderMode: state.get("App").get("identityProviderMode"),
  allowPassword: state.get("App").get("allowPassword"),
  identityProviderInfo: state.get("App").get("identityProviderInfo"),
  verifyLinkInvalid: state.get("App").get("verifyLinkInvalid"),
  resendVerificationEmailSuccess: state
    .get("App")
    .get("resendVerificationEmailSuccess"),
  checkValidVerifyTokenLoading: state
    .get("App")
    .get("checkValidVerifyTokenLoading"),
  showUserVerified: state.get("App").get("showUserVerified"),
});

function mapDispatchToProps(dispatch) {
  return {
    onLogin: (formData, liOnboarding, liOnboardingIntegrationData) =>
      dispatch(login(formData, liOnboarding, liOnboardingIntegrationData)),
    onResetPassword: (emailAddress, action) =>
      dispatch(resetPassword(emailAddress, action)),
    onClearResetEmailErrors: () => dispatch(clearResetEmailErrors()),
    onGetIdentityProvider: (emailAddress, companyAccountId /* rememberMe */) =>
      dispatch(
        getIdentityProvider(emailAddress, companyAccountId /* rememberMe */)
      ),
    onResetErrorCode: () => dispatch(resetErrorCode()),
    onCheckValidVerifyToken: (verifyToken) =>
      dispatch(checkValidVerifyToken(verifyToken)),
    onResendVerificationEmail: (emailAddress) =>
      dispatch(resendVerificationEmail(emailAddress)),
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
